export default __webpack_public_path__ + "static/media/TTP_Broken Promises_Appendix A.908cbbc3.pdf";